import React, { useEffect, useState, useRef } from "react";
import { Radio, Button, Modal, Form, Input, Card, Space, Select, InputNumber, Transfer, Table } from 'antd';
import { BreathAPIs } from "../../../APIs/BreathAPIs";
import styles from "./styles.module.css";
import { MinusCircleOutlined, PlusCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { toast } from 'react-toastify';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { Toast } from "react-bootstrap";
import { IoMdCloseCircle } from 'react-icons/io';


const AddNewUsers = ({ showAddNewUsersModal, currentUserGroup, setExpandedRowData, expandedRowData, setShowAddNewUsersModal }) => {

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [pagination, setPagination] = useState({
    total: 0,
    current: 1,
    pageSize: 10,
    totalPages: 0
  });
  const [usersTableToggle, setUsersTableToggle] = useState('availableUsers')
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [form] = Form.useForm();
  // console.log('expanded row data: ', expandedRowData);
  // console.log('current user group: ',currentUserGroup);
  // console.log('users: ',users);
  // console.log('selected users: ',selectedUsers);
  async function fetchUsers(page = 1, pageSize = 10) {

    setIsLoading(true);

    const { filterEmail, filterContact, filterFirstName, filterLastName } = form.getFieldsValue();

    let currentUserGroupMembers = expandedRowData.find((userGroup) => userGroup._id === currentUserGroup._id)?.data?.userGroupMembers || [];
    currentUserGroupMembers = currentUserGroupMembers.map((userGroupMember) => (userGroupMember._id))

    console.log('current user group members: ',currentUserGroupMembers);
    const result = await BreathAPIs.getUpdatedUserList({
      userGroupId: currentUserGroup._id,
      userGroupMembers: currentUserGroupMembers,
      page: page,
      limit: pageSize,
      filterEmail: filterEmail ? filterEmail : null,
      filterFirstName: filterFirstName ? filterFirstName : null,
      filterLastName: filterLastName ? filterLastName : null,
      filterContact: filterContact ? filterContact : null

    });


    // console.log('original user list: ', result.data.userList);

    setUsers(result.data.userList)


    setPagination({
      total: result.data.pagination.total,
      current: result.data.pagination.current,
      pageSize: result.data.pagination.pageSize,
      // totalPages: parseInt(Math.ceil(updatedUserList.length/result.data.pagination.pageSize))
      totalPages: result.data.pagination.totalPages
    });
    setIsLoading(false)
  }
  async function userSubmit() {
    try {

      // const newObject = { _id: currentUserGroup._id, userGroupMembers: selectedUsers }
      // setAddUserGroupMembersData((prev) => {
      //   const result = prev.find((userGroup) => userGroup._id === newObject._id);

      //   if (result) {
      //     return prev.map((userGroup) =>
      //       userGroup._id === newObject._id
      //         ? { ...userGroup, userGroupMembers: [...userGroup.userGroupMembers, ...selectedUsers] }
      //         : userGroup
      //     );
      //   } else {
      //     return [...prev, newObject];
      //   }
      // });
      setIsLoadingSubmit(true);
      const response = await BreathAPIs.addUserGroupMembers({ _id: currentUserGroup._id, userGroupMembers: selectedUsers })
      // console.log('response: ',response);

      if (response.status === 200) {

        setExpandedRowData(prev => {

          return prev.map(item =>
            item._id === currentUserGroup._id ? {
              ...item,
              data: response.data.data
              // {
              //   pagination: {
              //     total: response.data.data.pagination.total,
              //     current: response.data.data.pagination.current,
              //     pageSize: response.data.data.pagination.pageSize,
              //     totalPages: response.data.data.pagination.totalPages,

              //   },
              //   userGroupMembers: response.data.data.userGroupMembers,
              // }
            } : item
          );






        })

        setShowAddNewUsersModal(false);
        setSelectedUsers([]);
        setUsers([]);
        toast.success(response.data.message);
        setIsLoadingSubmit(false);

      }

    } catch (error) {
      console.error('Error in adding users to usergroup:', error.message);
      toast.error(error.response.data.message)
      setIsLoadingSubmit(false);

    }
    // console.log('selected users: ',selectedUsers);





  }
  // function userSubmit() {
  //   console.log('selected users:', selectedUsers);
  //   const groupId = currentUserGroup._id;
  //   const newMembers = selectedUsers; // alias for clarity
  //   const newMembersCount = newMembers.length;

  //   // Update addUserGroupMembersData
  //   setAddUserGroupMembersData((prev) => {
  //     // Find the index of the current group
  //     const groupIndex = prev.findIndex((group) => group._id === groupId);

  //     if (groupIndex !== -1) {
  //       // Merge new members with existing members for the matching group
  //       const updatedGroup = {
  //         ...prev[groupIndex],
  //         userGroupMembers: [...prev[groupIndex].userGroupMembers, ...newMembers],
  //       };

  //       // Create a new array with the updated group
  //       return [
  //         ...prev.slice(0, groupIndex),
  //         updatedGroup,
  //         ...prev.slice(groupIndex + 1),
  //       ];
  //     } else {
  //       // If group not found, add a new object
  //       return [...prev, { _id: groupId, userGroupMembers: newMembers }];
  //     }
  //   });

  //   // Update expandedRowData
  //   setExpandedRowData((prev) =>
  //     prev.map((item) => {
  //       if (item._id !== groupId) return item;

  //       const existingMembers = item.data.userGroupMembers;
  //       const updatedMembers = [...existingMembers, ...newMembers];
  //       const totalMembers = updatedMembers.length;

  //       return {
  //         ...item,
  //         data: {
  //           userGroupMembers: updatedMembers,
  //           pagination: {
  //             total: totalMembers,
  //             current: 1,
  //             pageSize: 10,
  //             totalPages: Math.ceil(totalMembers / 10),
  //           },
  //         },
  //       };
  //     })
  //   );

  //   setShowAddNewUsersModal(false);
  //   setSelectedUsers([]);
  //   setUsers([]);
  // }


  const handleTableChange = (pagination) => {
    const { current, pageSize } = pagination;
    fetchUsers(current, pageSize);
  };

  useEffect(() => {
    fetchUsers();
  }, [])

  // const rowSelection = {
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  //     // setSelectedUsers((prev)=>{
  //     //   return [...prev,selectedRows]
  //     // })
  //     setSelectedUsers(selectedRows)

  //   }
  // };

  // const handleSearch = (selectedKeys, confirm, dataIndex) => {
  //   confirm();
  //   setSearchText(selectedKeys[0]);
  //   setSearchedColumn(dataIndex);
  //   // setUserGroupUsersData((prevUsers) =>
  //   //   prevUsers.filter((user) =>
  //   //     user[dataIndex].toString().toLowerCase().includes(selectedKeys[0].toLowerCase())
  //   //   )
  //   // );
  // };


  // const handleReset = (clearFilters) => {
  //   clearFilters();
  //   setSearchText('');
  //   setSearchedColumn('');
  //   // setUserGroupUsersData(originalUserGroupUsersData);
  // };


  // const getColumnSearchProps = (dataIndex) => ({
  //   filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
  //     <div
  //       style={{
  //         padding: 8,
  //       }}
  //       onKeyDown={(e) => e.stopPropagation()}
  //     >
  //       <Input
  //         ref={searchInput}
  //         placeholder={`Search ${dataIndex}`}
  //         value={selectedKeys[0]}
  //         onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
  //         onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
  //         style={{
  //           marginBottom: 8,
  //           display: 'block',
  //         }}
  //       />
  //       <Space>
  //         <Button
  //           type="primary"
  //           onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
  //           icon={<SearchOutlined />}
  //           size="small"
  //           style={{
  //             width: 90,
  //           }}
  //         >
  //           Search
  //         </Button>
  //         <Button
  //           onClick={() => clearFilters && handleReset(clearFilters)}
  //           size="small"
  //           style={{
  //             width: 90,
  //           }}
  //         >
  //           Reset
  //         </Button>
  //         <Button
  //           type="link"
  //           size="small"
  //           onClick={() => {
  //             confirm({
  //               closeDropdown: true,
  //             });
  //             setSearchText(selectedKeys[0]);
  //             setSearchedColumn(dataIndex);
  //           }}
  //         >
  //           Filter
  //         </Button>
  //         <Button
  //           type="link"
  //           size="small"
  //           onClick={close}
  //         >
  //           Close
  //         </Button>
  //       </Space>
  //     </div>
  //   ),
  //   filterIcon: (filtered) => (
  //     <SearchOutlined
  //       style={{
  //         color: filtered ? '#1677ff' : undefined,
  //       }}
  //     />
  //   ),
  //   onFilter: (value, record) =>
  //     record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  //   filterDropdownProps: {
  //     onOpenChange(open) {
  //       if (open) {
  //         setTimeout(() => searchInput.current?.select(), 100);
  //       }
  //     },
  //   },
  //   render: (text) =>
  //     searchedColumn === dataIndex ? (
  //       <Highlighter
  //         highlightStyle={{
  //           backgroundColor: '#ffc069',
  //           padding: 0,
  //         }}
  //         searchWords={[searchText]}
  //         autoEscape
  //         textToHighlight={text ? text.toString() : ''}
  //       />
  //     ) : (
  //       text
  //     ),
  // });

  const handleUsers = (user) => {

    selectedUsers.find((selectedUser) => selectedUser._id === user._id) ?
      (
        setSelectedUsers((selectedUsers) => {
          return selectedUsers.filter((selectedUser) => selectedUser._id !== user._id)
        })
      )
      :
      (
        setSelectedUsers([...selectedUsers, user])
      )


  }


  const columns = [
    {
      render: (text, record) => (

        <Button
          onClick={() => {
            handleUsers(record)
          }}
          className={selectedUsers.find((selectedUser) => selectedUser._id === record._id) ? styles['removeButton'] : styles['addButton']}
          icon={selectedUsers.find((selectedUser) => selectedUser._id === record._id) ? <MinusCircleOutlined /> : <PlusCircleOutlined />}

        />

      ),
      width: 15
    }
    ,
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',

      width: '2.5rem',
      // ...getColumnSearchProps('firstName')
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      width: '2.5rem'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      // ...getColumnSearchProps('email'),
      width: '2.5rem'
    },


  ];


  const handleClearFilter = () => {
    form.resetFields();
    fetchUsers()
  };


  return (
    <>
      <Toast></Toast>
      <Modal
        title="Add New Users"
        open={showAddNewUsersModal}
        onCancel={() => {
          setShowAddNewUsersModal(false);
          setSelectedUsers([]);
          setUsers([]);
        }}
        okText='Submit'
        onOk={() => {
          userSubmit()
        }}
        confirmLoading={isLoadingSubmit}
      >

        <div style={{ display: 'block', marginBottom: '1rem', textAlign: 'center' }}>

          <Radio.Group block
            options={[
              {
                label: 'Available Users',
                value: 'availableUsers',
              },
              {
                label: 'Selected Users',
                value: 'selectedUsers',
              },

            ]}
            defaultValue={usersTableToggle}
            style={{ width: '100%' }}
            onChange={(event) => { setUsersTableToggle(event.target.value) }}
            optionType="button"

          />

        </div>

        <div>
          {usersTableToggle === 'availableUsers' ?
            <>
            <div className={styles['modal-filter']}>


<Form
  initialValues={{
    filterEmail: '',
    filterContact: '',
    filterFirstName: '',
    filterLastName: '',

  }}
  form={form}
  layout="inline"

>
  <div className={styles['modal-filter-left']}>
    <Form.Item name="filterFirstName" >
      <Input
        placeholder='First Name: John'
      />
    </Form.Item>
    <Form.Item name="filterLastName" >
      <Input
        placeholder='Last Name: Smith'
      />
    </Form.Item>
    <Form.Item name="filterContact" >
      <Input
        placeholder='Contact: 415-555-1234'
      />
    </Form.Item>
    <Form.Item name="filterEmail" >
      <Input
        placeholder="Email: eg:example@email.com"
      />
    </Form.Item>
  </div>
</Form>

<div className={styles['modal-filter-right']}>

  <Button onClick={() => {
    fetchUsers()
    // getUserGroupMembers(true, record, response.data.pagination.current, response.data.pagination.pageSize, true)
  }} type="primary">
    Filter
  </Button>
  <Button onClick={() => {
    handleClearFilter();
  }} className={styles['custom-btn']} type="primary" danger color='white' shape="circle" icon={<IoMdCloseCircle />} />
</div>
</div>
              <Table columns={columns}
                dataSource={users}

                rowKey="_id"
                size="middle"
                pagination={pagination}
                onChange={handleTableChange}
                bordered
                scroll={{ auto: 'calc(600px + 50%)' }}
                loading={isLoading}
                onRow={(record) => ({
                  style: selectedUsers.some((selectedUser) => selectedUser._id === record._id)
                    ? { backgroundColor: '#e6f7ff' }  // light blue
                    : {},
                })}
              />
              
            </>
            :
            <Table
              rowKey="_id"
              size="middle"
              bordered
              columns={columns}
              dataSource={selectedUsers}
              scroll={{ auto: 'calc(600px + 50%)' }}

            />
          }
        </div>


      </Modal>
    </>
  )
}

export default AddNewUsers